import { Box } from '@fhs-legacy/universal-components';

export const Heading = Box.withConfig({
  paddingTop: {
    desktop: 5,
  },
});
